export const quizQuestions = [
  {
    id: 1,
    block: 'oferta',
    question: '¿Cómo describes tu oferta a un prospecto en los primeros 30 segundos?',
    options: [
      {
        label: 'A',
        text: '"Depende del cliente, lo adapto cada vez"',
        points: 1,
        microcopy: 'Si tu oferta cambia con cada prospecto, el mercado no sabe qué compras.'
      },
      {
        label: 'B',
        text: '"Tengo una idea general pero no está escrita ni estandarizada"',
        points: 2,
        microcopy: 'Una oferta en tu cabeza no escala. Si no está escrita, no existe.'
      },
      {
        label: 'C',
        text: '"Tengo un pitch claro pero no lo he testeado con datos"',
        points: 3,
        microcopy: 'Buen inicio. Falta validarlo con métricas reales de conversión.'
      },
      {
        label: 'D',
        text: '"Tengo una oferta estandarizada con propuesta de valor clara, probada y optimizada"',
        points: 4,
        microcopy: 'Esto es lo que separa agencias que escalan de las que improvisan.'
      }
    ]
  },
  {
    id: 2,
    block: 'oferta',
    question: '¿Sabes exactamente quién es tu cliente ideal y quién NO lo es?',
    options: [
      {
        label: 'A',
        text: '"Trabajo con cualquiera que pueda pagar"',
        points: 1,
        microcopy: 'Sin filtro de entrada, acabas cerrando clientes que destruyen tu margen y tu energía.'
      },
      {
        label: 'B',
        text: '"Tengo una idea pero no criterios escritos para cualificar"',
        points: 2,
        microcopy: 'Sin criterios claros, cada llamada es una apuesta.'
      },
      {
        label: 'C',
        text: '"Tengo un perfil definido pero no lo uso activamente para filtrar"',
        points: 3,
        microcopy: 'Tener el perfil sin usarlo es como tener un GPS apagado.'
      },
      {
        label: 'D',
        text: '"Tengo ICP definido con criterios de cualificación y descalificación activos"',
        points: 4,
        microcopy: 'Perfecto. Esto reduce llamadas inútiles y sube la tasa de cierre.'
      }
    ]
  },
  {
    id: 3,
    block: 'oferta',
    question: 'Cuando un prospecto te dice "es caro" o "lo tengo que pensar", ¿qué haces?',
    options: [
      {
        label: 'A',
        text: '"Bajo el precio o doy descuento"',
        points: 1,
        microcopy: 'Si tu respuesta a objeciones es bajar precio, el problema no es el precio — es el valor percibido.'
      },
      {
        label: 'B',
        text: '"Intento convencerlo pero no tengo un proceso claro"',
        points: 2,
        microcopy: 'Sin un framework de objeciones, cada "no" es un deal perdido innecesariamente.'
      },
      {
        label: 'C',
        text: '"Tengo algunas respuestas preparadas pero no las he optimizado"',
        points: 3,
        microcopy: 'Estás cerca. Falta sistematizar las 10 objeciones más frecuentes.'
      },
      {
        label: 'D',
        text: '"Tengo un playbook de objeciones documentado y entrenado"',
        points: 4,
        microcopy: 'Así se cierra de forma consistente, no "según el día".'
      }
    ]
  },
  {
    id: 4,
    block: 'oferta',
    question: '¿Cuántas propuestas enviaste el mes pasado y cuántas se cerraron?',
    options: [
      {
        label: 'A',
        text: '"No llevo ese registro"',
        points: 1,
        microcopy: 'Si no mides propuestas vs cierres, no sabes si tu problema es volumen o conversión.'
      },
      {
        label: 'B',
        text: '"Envié varias pero no sé el número exacto ni la tasa"',
        points: 2,
        microcopy: 'Sin este dato, cada mes es una moneda al aire.'
      },
      {
        label: 'C',
        text: '"Lo sé aproximadamente: envié X y cerré Y"',
        points: 3,
        microcopy: 'Aproximado no es suficiente. Las decisiones se toman con datos exactos.'
      },
      {
        label: 'D',
        text: '"Lo tengo medido: X propuestas, Y cerradas, tasa de Z%"',
        points: 4,
        microcopy: 'Esto es control real. Ahora puedes optimizar cada punto del proceso.'
      }
    ]
  },
  {
    id: 5,
    block: 'oferta',
    question: '¿Tu precio refleja el valor que entregas o compites por ser más barato?',
    options: [
      {
        label: 'A',
        text: '"Compito por precio casi siempre"',
        points: 1,
        microcopy: 'Competir por precio es una carrera que solo gana el que está dispuesto a perder más dinero.'
      },
      {
        label: 'B',
        text: '"Mi precio es bajo pero no sé cómo subirlo sin perder clientes"',
        points: 2,
        microcopy: 'El problema no es el precio. Es que el prospecto no ve la diferencia.'
      },
      {
        label: 'C',
        text: '"Mi precio está bien pero algunos prospectos me comparan con opciones baratas"',
        points: 3,
        microcopy: 'Eso se resuelve con posicionamiento y oferta, no con argumentos.'
      },
      {
        label: 'D',
        text: '"Mi precio refleja mi valor y rara vez es un problema en la venta"',
        points: 4,
        microcopy: 'Cuando el valor está claro, el precio deja de ser la conversación.'
      }
    ]
  },
  {
    id: 6,
    block: 'marketing',
    question: '¿De dónde vienen tus clientes hoy?',
    options: [
      {
        label: 'A',
        text: '"Referidos y boca a boca, básicamente"',
        points: 1,
        microcopy: 'Referidos es genial, pero no es un sistema. Es suerte repetida.'
      },
      {
        label: 'B',
        text: '"Mezcla de referidos y algo de contenido o ads, pero sin consistencia"',
        points: 2,
        microcopy: 'Tener varios canales sin uno dominado es no tener ninguno.'
      },
      {
        label: 'C',
        text: '"Tengo un canal principal pero no lo he optimizado con métricas"',
        points: 3,
        microcopy: 'Un canal sin métricas es un canal a ciegas.'
      },
      {
        label: 'D',
        text: '"Tengo un canal principal con cadencia semanal, métricas y flujo predecible"',
        points: 4,
        microcopy: 'Esto es un motor de oportunidades real. La base para escalar.'
      }
    ]
  },
  {
    id: 7,
    block: 'marketing',
    question: '¿Cuántas reuniones de venta tienes agendadas esta semana?',
    options: [
      {
        label: 'A',
        text: '"Ninguna — no tengo forma de predecirlo"',
        points: 1,
        microcopy: 'Sin reuniones predecibles, tu facturación es una ruleta rusa cada mes.'
      },
      {
        label: 'B',
        text: '"1-2, pero depende de si alguien me contacta"',
        points: 2,
        microcopy: 'Esperar a que te contacten no es una estrategia comercial.'
      },
      {
        label: 'C',
        text: '"3-5, pero varía mucho de semana a semana"',
        points: 3,
        microcopy: 'Hay volumen pero falta consistencia. Eso se arregla con cadencia.'
      },
      {
        label: 'D',
        text: '"Tengo un flujo consistente de 5+ reuniones cualificadas por semana"',
        points: 4,
        microcopy: 'Este es el nivel donde puedes elegir con quién trabajar.'
      }
    ]
  },
  {
    id: 8,
    block: 'marketing',
    question: '¿Qué porcentaje de tus reuniones son con prospectos realmente cualificados?',
    options: [
      {
        label: 'A',
        text: '"No lo sé, no mido eso"',
        points: 1,
        microcopy: 'Si no sabes cuántas reuniones son con tu ICP real, estás quemando tiempo y energía.'
      },
      {
        label: 'B',
        text: '"Menos de la mitad — muchas son pérdida de tiempo"',
        points: 2,
        microcopy: 'Cada reunión con alguien que no es tu cliente ideal te cuesta 2: el tiempo de esa reunión y la que no tuviste.'
      },
      {
        label: 'C',
        text: '"Más de la mitad pero me gustaría que fueran más"',
        points: 3,
        microcopy: 'Falta un filtro de cualificación antes de la llamada.'
      },
      {
        label: 'D',
        text: '"80%+ de mis reuniones son con prospectos que encajan perfectamente"',
        points: 4,
        microcopy: 'Así se cierra al 30-40%: llegando solo a reuniones que valen la pena.'
      }
    ]
  },
  {
    id: 9,
    block: 'marketing',
    question: '¿Tienes un sistema de show-rate (que la gente se presente a la reunión)?',
    options: [
      {
        label: 'A',
        text: '"No, a veces me dejan plantado y ya"',
        points: 1,
        microcopy: 'Cada no-show es una oportunidad que pagaste (con ads o con tiempo) y que se evapora.'
      },
      {
        label: 'B',
        text: '"Mando un recordatorio manual antes de la reunión"',
        points: 2,
        microcopy: 'Un recordatorio no es un sistema. Falta confirmación, reprogramación y recovery.'
      },
      {
        label: 'C',
        text: '"Tengo recordatorios automáticos pero no mido el show-rate"',
        points: 3,
        microcopy: 'Automatizar sin medir es optimizar a ciegas.'
      },
      {
        label: 'D',
        text: '"Tengo confirmación + recordatorio + reprogramación + mido show-rate (>85%)"',
        points: 4,
        microcopy: 'Esto solo lo tienen las operaciones comerciales serias.'
      }
    ]
  },
  {
    id: 10,
    block: 'marketing',
    question: '¿Cuánto inviertes en generar oportunidades y cuánto retorno te da?',
    options: [
      {
        label: 'A',
        text: '"No lo sé con certeza"',
        points: 1,
        microcopy: 'Si no sabes tu coste por oportunidad, no sabes si tu negocio es rentable o lo parece.'
      },
      {
        label: 'B',
        text: '"Invierto algo pero no sé el ROI exacto"',
        points: 2,
        microcopy: 'Invertir sin medir retorno es como conducir sin velocímetro.'
      },
      {
        label: 'C',
        text: '"Lo tengo más o menos calculado pero no al detalle"',
        points: 3,
        microcopy: 'El "más o menos" es donde se esconden las fugas de dinero.'
      },
      {
        label: 'D',
        text: '"Sé exactamente mi CAC, mi ROI por canal y mi coste por reunión"',
        points: 4,
        microcopy: 'Con estos datos puedes escalar con confianza. Sin ellos, escalar es jugar a la ruleta.'
      }
    ]
  },
  {
    id: 11,
    block: 'ventas',
    question: '¿Tienes un pipeline de ventas con etapas definidas?',
    options: [
      {
        label: 'A',
        text: '"No, todo está en mi cabeza o en notas sueltas"',
        points: 1,
        microcopy: 'Sin pipeline, no puedes ver dónde mueren tus oportunidades. Y están muriendo.'
      },
      {
        label: 'B',
        text: '"Tengo un CRM pero no lo uso de forma consistente"',
        points: 2,
        microcopy: 'Un CRM sin proceso es una base de datos cara.'
      },
      {
        label: 'C',
        text: '"Tengo etapas definidas pero no criterios claros de avance"',
        points: 3,
        microcopy: 'Las etapas sin criterios son carpetas, no un sistema.'
      },
      {
        label: 'D',
        text: '"Pipeline con etapas, criterios de avance, tiempos máximos y revisión semanal"',
        points: 4,
        microcopy: 'Esto es un pipeline que gobierna el negocio, no que lo decora.'
      }
    ]
  },
  {
    id: 12,
    block: 'ventas',
    question: '¿Quién cierra las ventas en tu empresa?',
    options: [
      {
        label: 'A',
        text: '"Yo, siempre yo"',
        points: 1,
        microcopy: 'Si tú eres el closer, tu negocio tiene un techo: tu tiempo.'
      },
      {
        label: 'B',
        text: '"Yo principalmente, a veces alguien me ayuda pero sin proceso"',
        points: 2,
        microcopy: 'Delegar sin playbook es delegar el caos.'
      },
      {
        label: 'C',
        text: '"Tengo a alguien pero depende de mí para los cierres importantes"',
        points: 3,
        microcopy: 'Estás a medio camino. Falta un playbook y QA semanal.'
      },
      {
        label: 'D',
        text: '"Tengo un vendedor/closer con playbook, entrenamiento y métricas propias"',
        points: 4,
        microcopy: 'Así se escala: el sistema vende, no la persona.'
      }
    ]
  },
  {
    id: 13,
    block: 'ventas',
    question: '¿Qué pasa cuando un prospecto dice "déjame pensarlo" o desaparece?',
    options: [
      {
        label: 'A',
        text: '"Lo dejo ir. Si quiere, volverá"',
        points: 1,
        microcopy: 'El 80% de las ventas se pierden por falta de seguimiento, no por falta de interés.'
      },
      {
        label: 'B',
        text: '"Le mando un mensaje o dos y si no responde, lo dejo"',
        points: 2,
        microcopy: '2 mensajes no es follow-up. Es rendirse con educación.'
      },
      {
        label: 'C',
        text: '"Tengo una idea de seguimiento pero no una secuencia estructurada"',
        points: 3,
        microcopy: 'Sin secuencia, cada follow-up depende de tu memoria y tu energía del día.'
      },
      {
        label: 'D',
        text: '"Tengo secuencias de seguimiento por estado: ghosting, indeciso, post-propuesta"',
        points: 4,
        microcopy: 'Esto es lo que separa a los que cierran al 35% de los que cierran al 10%.'
      }
    ]
  },
  {
    id: 14,
    block: 'ventas',
    question: '¿Mides tu tasa de cierre y sabes cómo mejorarla?',
    options: [
      {
        label: 'A',
        text: '"No mido mi tasa de cierre"',
        points: 1,
        microcopy: 'Si no mides, no puedes mejorar. Y si no mejoras, te estancas.'
      },
      {
        label: 'B',
        text: '"Sé que cierro poco pero no tengo el dato exacto"',
        points: 2,
        microcopy: '"Cierro poco" no es un diagnóstico. Es una sensación. Los datos son el diagnóstico.'
      },
      {
        label: 'C',
        text: '"Sé mi tasa pero no tengo un plan claro para mejorarla"',
        points: 3,
        microcopy: 'El dato sin acción es solo un número triste en una hoja de cálculo.'
      },
      {
        label: 'D',
        text: '"Mido mi tasa, reviso llamadas semanalmente y tengo un plan de mejora activo"',
        points: 4,
        microcopy: 'Esto es operar como una máquina comercial, no como un freelance con suerte.'
      }
    ]
  },
  {
    id: 15,
    block: 'ventas',
    question: 'Si mañana quisieras duplicar tu facturación, ¿qué harías?',
    options: [
      {
        label: 'A',
        text: '"No tengo ni idea, probablemente meter más ads"',
        points: 1,
        microcopy: 'Más ads sin sistema es echar gasolina a un motor roto.'
      },
      {
        label: 'B',
        text: '"Intentaría conseguir más leads y trabajar más horas"',
        points: 2,
        microcopy: 'Más horas no es una estrategia de crecimiento. Es una receta para quemarte.'
      },
      {
        label: 'C',
        text: '"Tengo algunas ideas pero no sé cuál palanca mover primero"',
        points: 3,
        microcopy: 'Sin un scoreboard, no puedes ver cuál palanca tiene más impacto.'
      },
      {
        label: 'D',
        text: '"Sé exactamente qué métrica mover, en qué parte del proceso, para lograr ese salto"',
        points: 4,
        microcopy: 'Esto es claridad comercial. Desde aquí se escala con control.'
      }
    ]
  }
];